import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3v18h18V3zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
}), 'InsertChartSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/InsertChartSharp.js
// module id = 4262
// module chunks = 2